<template>
	<v-container fluid>
		<BuyerEmailModal :show="buyerEmailModal.show" :contact="buyerEmailModal.contact"
						 :opportunity="buyerEmailModal.opportunity" @callback="buyerEmailModalCallback"/>
		<v-layout row wrap>
			<v-flex xs12 v-if="databaseUpdateNeeded === true">
				<v-card style="border-left:5px solid red; text-align:center; line-height:10px; background-color:#f8cfcf;">
				<span
					style="display:inline-block; color:grey; font-size:12px; margin-top:8px;"><b>{{ $t('labels.databaseOutdated') }}</b></span><br><br>
				</v-card>
			</v-flex>
			<v-flex xs12>
				<span
					style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{
						$t('labels.reportsOpportunityBuyer')
					}}</b></span><br><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex md3 xs12 offset-md1>
				<Dropdown
					v-model="opportunity"
					:ajax="true"
					:loader="true"
					:data="'opportunities'"
					:label="'* '+$t('labels.opportunityId')"></Dropdown>
				<InputField
					v-model="opportunity.category"
					:label="$t('fields.realestateType')"
					:readonly="true"></InputField>
				<InputField
					v-model="opportunity.county"
					:label="$t('fields.county')"
					:readonly="true"></InputField>
				<InputField
					v-model="opportunity.city"
					:label="$t('fields.city')"
					:readonly="true"></InputField>
				<InputField
					v-model="opportunity.location"
					:label="$t('fields.neighbourhood')"
					:readonly="true"></InputField>
				<v-btn v-if="opportunity.id != null" color="grey lighten-1" @click="checkOpportunity" class="my-4">
					{{ $t('buttons.checkOpportunity') }}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap pt-4>
			<v-flex xs1 v-if="contactsTable.items.length != 0" pl-1>
				<v-tooltip bottom>
					<v-btn @click="selectAll" icon slot="activator">
						<span v-if="this.selectedAll != true"><v-icon small>fa-check-square</v-icon></span>
						<span v-if="this.selectedAll == true"><v-icon small>far fa-square</v-icon></span>
					</v-btn>
					<span>{{ $t('labels.selectAll') }}</span>
				</v-tooltip>
			</v-flex>
			<v-flex xs1 v-if="contactsTable.items.length != 0">
				<v-btn @click="sendEmails" color="grey lighten-1">
					<v-icon small>fa-envelope</v-icon>&nbsp;&nbsp;{{ $t('buttons.reportSendEmails') }}
				</v-btn>
			</v-flex>
			<v-flex xs10 v-if="contactsTable.items.length != 0" text-xs-right>
				<v-tooltip bottom>
					<v-btn @click="excelExport" icon slot="activator">
						<v-icon small>fa-file-excel</v-icon>
					</v-btn>
					<span>{{ $t('tooltips.excel') }}</span>
				</v-tooltip>
			</v-flex>
			<v-flex xs12 v-if="contactsTable.items.length == 0" text-xs-right>
				<v-tooltip bottom>
					<v-btn @click="excelExport" icon slot="activator">
						<v-icon small>fa-file-excel</v-icon>
					</v-btn>
					<span>{{ $t('tooltips.excel') }}</span>
				</v-tooltip>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<DataTableContacts
					:excel="false"
					:filter="false"
					:headers="contactsTable.headers"
					:items="contactsTable.items"
					:total="contactsTable.total"
					@reload="reloadData"
					@excel="excelExport"
				>
					<template #row="props">
						<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.index)">
							<td width="100px" style="text-align:center">
								<CheckBox v-model="props.item.selected" :simple="true"></CheckBox>
							</td>
							<td width="100px" style="text-align:center">
								<v-tooltip bottom v-if="props.item.brochure_sent">
									<v-btn slot="activator" icon>
										<v-icon small v-if="props.item.brochure_sent">fa-envelope</v-icon>
									</v-btn>
									<span>{{ $t('labels.reportBrochuresSent') }}</span>
								</v-tooltip>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.vtiger_id }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.first_name }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.last_name }}
							</td>
							<td width="150px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.contact_type }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.communication_language }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.country }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.rooms_no }}
							</td>
							<td width="150px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.price_from }}
							</td>
							<td width="150px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.price_to }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.area_from }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.area_to }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.sea_1st">fa-check</v-icon>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.sea_2nd">fa-check</v-icon>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.sea_view">fa-check</v-icon>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.elevator">fa-check</v-icon>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.garden">fa-check</v-icon>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.pool">fa-check</v-icon>
							</td>
						</tr>
					</template>
				</DataTableContacts>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import Opportunity from "../models/Opportunity";
import Dropdown from "./trinkets/Dropdown";
import CheckBox from "./trinkets/CheckBox";
import InputField from "./trinkets/InputField";
import QuantityField from './trinkets/QuantityField';
import CurrencyField from './trinkets/CurrencyField.vue';
import DataTableContacts from "./trinkets/DataTableContacts";
import BuyerEmailModal from "./BuyerEmailModal";

export default {
	name: "ReportsRealestate",
	components: {BuyerEmailModal, DataTableContacts, InputField, Dropdown, CurrencyField, QuantityField, CheckBox},
	data: function () {
		return {
			contactsTable: {
				headers: [
					{text: '', value: 'selected', type: '', sortable: false, searchable: false},
					{text: '', value: 'brochure_sent', type: '', sortable: false, searchable: false},
					{text: this.$t('fields.vtigerIdContact'), value: 'vtiger_id', type: 'string', searchable: false},
					{text: this.$t('fields.firstName'), value: 'firstName', type: 'string', searchable: false},
					{text: this.$t('fields.lastName'), value: 'lastName', type: 'string', searchable: false},
					{text: this.$t('fields.contactType'), value: 'contact_type', type: 'string', searchable: false},
					{
						text: this.$t('fields.communicationLanguage'),
						value: 'communication_language',
						type: 'string',
						searchable: false
					},
					{text: this.$t('fields.country'), value: 'country', type: 'string', searchable: false},
					{text: this.$t('fields.roomsNo'), value: 'rooms_no', type: 'string', searchable: false},
					{text: this.$t('fields.priceFrom'), value: 'price_from', type: 'string', searchable: false},
					{text: this.$t('fields.priceTo'), value: 'price_to', type: 'string', searchable: false},
					{text: this.$t('fields.areaFrom'), value: 'area_from', type: 'string', searchable: false},
					{text: this.$t('fields.areaTo'), value: 'area_to', type: 'string', searchable: false},
					{text: this.$t('fields.sea1st'), value: 'sea_1st', type: 'string', searchable: false},
					{text: this.$t('fields.sea2nd'), value: 'sea_2nd', type: 'string', searchable: false},
					{text: this.$t('fields.seaView'), value: 'sea_view', type: 'string', searchable: false},
					{text: this.$t('fields.elevator'), value: 'elevator', type: 'string', searchable: false},
					{text: this.$t('fields.garden'), value: 'garden', type: 'string', searchable: false},
					{text: this.$t('fields.pool'), value: 'pool', type: 'string', searchable: false},
				],
				items: [],
				total: 0,
				lastRequest: null
			},
			opportunity: new Opportunity({}),
			selectedAll: true,
			selectedContacts: [],
			buyerEmailModal: {
				show: false,
				contact: null,
				opportunity: null
			},
			currentContactIndex: null,
			latestUpdateTime: null,
			databaseUpdateNeeded: false,
		}
	},
	watch: {
		opportunity: {
			handler: function () {
				this.reloadData();
			},
			deep: true
		},
	},
	methods: {
		loadContactIntoModal() {
			this.buyerEmailModal.contact = this.contactsTable.items[this.currentContactIndex];
			this.buyerEmailModal.opportunity = this.opportunity;
			this.$nextTick(() => {
				this.buyerEmailModal.show = true;
			});
		},
		buyerEmailModalCallback() {
			this.buyerEmailModal.show = false;
			this.buyerEmailModal.contact = null;
			this.buyerEmailModal.opportunity = null;

			this.currentContactIndex++;
			if (this.currentContactIndex === this.contactsTable.items.length) {
				this.currentContactIndex = null;
				return;
			}
			while (!this.contactsTable.items[this.currentContactIndex].selected) {
				this.currentContactIndex++;
				if (this.currentContactIndex === this.contactsTable.items.length) {
					this.currentContactIndex = null;
					return;
				}
			}

			this.$nextTick(() => {
				this.loadContactIntoModal();
			});
		},
		sendEmails() {
			for (const index in this.contactsTable.items) {
				let contact = this.contactsTable.items[index];
				if (contact.selected === true) {
					this.currentContactIndex = index;
					this.loadContactIntoModal();
					return;
				}
			}
			this.$alert(this.$t('alerts.noContactsSelected'));
		},
		editClick(item) {
			item.selected = !item.selected;
		},
		selectAll() {
			for (const element of this.contactsTable.items) {
				element.selected = this.selectedAll;
			}
			this.selectedAll = !this.selectedAll;
		},
		reloadData() {
			let vm = this;
			if (vm.opportunity != null && vm.opportunity != '') {
				this.$APICall('get', 'report-opportunity-buyers', vm.opportunity.vtiger_id, (data, success) => {
					if (success) {
						vm.contactsTable.items = data.items;
						vm.contactsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
		excelExport() {
			if (this.contactsTable.items != undefined && this.contactsTable.items != null) {
				if (this.contactsTable.items.length != 0) {
					this.$APICall('post', 'excel/report-opportunity-buyers', this.contactsTable.items, (data, success) => {
						window.open(data.link);
					});
				}
			}
		},
		checkOpportunity() {
			if (this.opportunity != null && this.opportunity != undefined) {
				let routeData = this.$router.resolve('/opportunities/' + this.opportunity.vtiger_id);
				window.open(routeData.href, '_blank');
			}
		}
	}
	,
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.reports'), href: '/#/reports', disabled: true}
		]);
		let vm = this;
		this.$APICall('get', 'latest-update-time-reports', {}, (data, success) => {
			if (success) {
				let now = new Date();
				if(data != null && data != undefined && Object.keys(data).length !== 0){
					vm.latestUpdateTime = new Date(data);
					vm.latestUpdateTime = new Date(vm.latestUpdateTime.getTime() + 30*60000);
					if(now > vm.latestUpdateTime){
						vm.databaseUpdateNeeded = true;
					}
				}
				else{
					vm.databaseUpdateNeeded = true;
				}
			}
			else{
				vm.databaseUpdateNeeded = true;
			}
		});
	}
}
</script>

<style scoped>

</style>
